import styled from 'styled-components';
import { darkGrey2, white } from '../../common/colors';

export const StyledButton = styled.button`
  width: auto;
  border: 1px solid ${darkGrey2};
  background-color: ${white};
  border-radius: 0;
  padding: 1rem 2rem;
  height: auto;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  text-transform: uppercase;
`;

export const StyledPage = styled.section`
  background-color: white;
  padding: 0 2rem 2rem;
`;
